import BaseModelAPI from '../BaseModelAPI';

export default class RepackingDetail extends BaseModelAPI {
	static entity = 'repackingdetail';
	static entityName = 'repackingdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.repackingId = '';
			this.repacking = {};
			this.deliveryInstructionDetailId = '';
			this.deliveryInstructionDetail = {};
			this.partId = '';
			this.part = {};
			this.repackStatusId = '';
			this.repackStatus = {};
			this.repackById = '';
			this.repackBy = {};
			this.startDate = '';
			this.finishDate = '';
			this.qtyRepack = 0;
			this.qtyOutstanding = 0;
			this.qtyFullfiled = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}